import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useAccess } from "../contexts/AccessContext";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const { loading, hasAccess, isPathVisible, firstVisiblePath } = useAccess();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Access-profile gating: a user with an assigned profile may only reach the
  // panels it enables. No profile → permissive (role-based visibility stands).
  // While permissions are still loading, render through to avoid a redirect flash.
  if (!loading && hasAccess && !isPathVisible(location.pathname)) {
    return <Navigate to={firstVisiblePath()} replace />;
  }

  return <>{children}</>;
}
